import { notifyError, panelType, ServiceList } from '@bimser/common';
import { BCMessage, BCNotification, findMessage } from '@bimser/components';
import { call } from 'redux-saga/effects';
import { actionRole, IRelatedPanel } from '../../../../../../common/entities';
import { openNewPanelInsteadOfTheOtherOne } from '../../../../../../common/sagas/commonSagas';

export interface FlowViewerParameters {
	parent?: IRelatedPanel;
	processId?: number;
	requestId?: number;
	projectName: string;
	flowName: string;
	projectCaption?: string;
	panelSize?: 1 | 2 | 3;
	closePanelGuid?: string;
	processRequestSecretKey?: string;
	forMobile?: boolean;
	then?: () => void;
	catch?: (error: any) => void;
}

export function* OpeneBAFlowViewer(parameters: FlowViewerParameters) {
	try {
		const request: any = {
			processId: parameters.processId,
			requestId: parameters.requestId
		};

		const url = yield ServiceList.workflow.workflowManagement.GeteBAWorkflowItemUrl.call(
			request,
			null,
			{ cache: false }
		);

		return yield call(openNewPanelInsteadOfTheOtherOne, parameters.closePanelGuid, {
			title: parameters.projectCaption,
			paneltype: panelType.eBAFlow,
			parent: parameters.parent,
			role: actionRole.flowForm,
			initialSize: parameters.panelSize || 2,
			size: parameters.panelSize || 2,
			extraProps: {
				url
			},
			canHandleCloseEvent: false,
			forMobile: parameters.forMobile
		});
	} catch (error) {
		if (error?.message == '-1') {
			BCNotification.warning({ message: findMessage.get('100742') });
		} else {
			yield call(notifyError, error);
		}
		return null;
	} finally {
		BCMessage.destroy('openFlowViewerLoading');
	}
}
